var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"constructor2-pulsating-dot",class:[`constructor2-pulsating-dot--direction-${_vm.direction}`, `constructor2-pulsating-dot--color-${_vm.color}`],attrs:{"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }